export default __webpack_public_path__ + "static/media/johnny.6f2ddb4a.jpg";